  import { defineStore } from "pinia";

  export const useLayoutStore = defineStore("layout", {
    state: () => ({
      layoutType: "vertical",
      leftSidebarType: "light",
      layoutWidth: "fluid",
      topbar: "dark",
      loader: false,
      mode: "light",
      sidebarCollapsed: localStorage.getItem('sidebar_collapsed') === 'true'
    }),
    actions: {
      changeLayoutType(layoutType) {
        this.layoutType = layoutType;
      },
      changeLayoutWidth(layoutWidth) {
        this.layoutWidth = layoutWidth;
      },
      changeLeftSidebarType(leftSidebarType) {
        this.leftSidebarType = leftSidebarType;
      },
      changeTopbar(topbar) {
        this.topbar = topbar;
      },
      changeLoaderValue(loader) {
        this.loader = loader;
      },
      changeMode(mode) {
        this.mode = mode
      },
      toggleSidebar() {
        this.sidebarCollapsed = !this.sidebarCollapsed;
        localStorage.setItem('sidebar_collapsed', this.sidebarCollapsed);
      },
      setSidebarCollapsed(value) {
        this.sidebarCollapsed = value;
        localStorage.setItem('sidebar_collapsed', value);
      }
    }
  });